import React, { useEffect, useRef, useState } from 'react'
import { Content } from 'antd/es/layout/layout'


import { useNavigate } from 'react-router-dom'
import { Breadcrumb, Collapse, Image, Select, Tooltip } from 'antd'
import { CFCDN, toAwning, toBlind, toPlantation } from '../../shop-front-component/ProductCollection'

import {  colourType, bracketColors, Color } from './data'


import { ArrowLeftOutlined,ArrowRightOutlined,LoadingOutlined } from '@ant-design/icons';


export default function PVCPlantationShutterPage() {
    const navigate = useNavigate()
    const [currentImage,setCurrentImage] = useState(CFCDN+"product-cover/plantation-shutter-4.jpeg")
    const [currentImageList,setCurrentImageList] = useState([CFCDN+"product-cover/plantation-shutter-4.jpeg",CFCDN+"pvc-plantation/IMG_6643.jpg",CFCDN+"pvc-plantation/IMG_6640.jpg",CFCDN+"pvc-plantation/IMG_0601.jpg",CFCDN+"pvc-plantation/IMG_6644.jpg",CFCDN+"pvc-plantation/IMG_6818.png",CFCDN+"pvc-plantation/IMG_6821.png"])
    
  
   
    const [currentSystemColor, setCurrentSystemColor] = useState<number>(0)
    
    const [installation,setInstallation] = useState(false)
   
    const   containerRef = useRef<HTMLDivElement>(null);;
    // useEffect(() => {
    //     // Initial load of images
    //     fetchMoreImages();
    // }, []);

  
    const scrollToParentEnd = (parentDevStr:string) => {
        const parentDiv = document.getElementById(parentDevStr); // Replace with your actual parent div id
        if (parentDiv) {
          const parentRect = parentDiv.getBoundingClientRect();
          window.scrollTo({
            top: parentRect.bottom + window.scrollY - window.innerHeight + 500,
            behavior: 'smooth',
          });
        }
      };
    

    useEffect(() => {
        const container = containerRef.current;
        
        const onScroll = () => {
            if (container){
                if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
                    fetchMoreImages();
                }
            }
            
        };

        if (container) {
            container.addEventListener('scroll', onScroll);
        }

        return () => {
            if (container) {
                container.removeEventListener('scroll', onScroll);
            }
        };
    }, [currentImageList]);

    const fetchMoreImages = () => {
        // Mock fetching more images (replace with your actual fetch logic)
        const newImages = currentImageList
        setCurrentImageList(prevList => [...prevList, ...newImages]);
    };

    const handleScroll = (scrollOffset:number) => {
        if(containerRef.current){
            containerRef.current.scrollBy({ left: scrollOffset, behavior: 'smooth' });
        }   
        
    };   



    /// LOAD MANAGEMENT

    const preloadImages = (srcArray: string[]): Promise<void[]> => {
        return Promise.all(
          srcArray.map(src => {
            return new Promise<void>((resolve, reject) => {
              const img = new window.Image();
              img.src = src;
              img.onload = () => resolve();
              img.onerror = reject;
            });
          })
        );
      };
    const [loading, setLoading] = useState(true);
    
    useEffect(() => {
        const imageSources = currentImageList.map(item => item);
        preloadImages(imageSources)
        .then(() => setLoading(false))
        .catch(err => console.error('Failed to preload images', err));
    }, []);
    
    
    if (loading) {
        return  <div className='hedvig-letters-sans-regular  p-1 flex items-center justify-center h-[100vh] w-full bg-white'>
        <Content className=' bg-transparent max-w-screen-2xl m-auto px-2 flex items-center justify-center'>
            <LoadingOutlined color="#000000" style={{fontSize:40}}/>
        </Content>
        </div>
      }

  return (
      <div className='hedvig-letters-sans-regular bg-white p-1'>
            <Content className=' bg-transparent max-w-screen-2xl m-auto px-2 ' >
                <div className=" mx-auto gap-5 h-[fit] mt-5">
                    <div className="flex flex-col lg:flex-row gap-5 ">
                        {/* Left Column */}
                        <div className=' w-full lg:w-7/12 '>
                            <div className='sticky top-32 '>
                                <div className='w-full flex justify-center aspect-video overflow-hidden shadow-md  border-none bg-white rounded-lg mx-auto overflow-hidden' >
                                                <Image
                                                    src={currentImage}      
                                                    alt="Centered Image"
                                                    height={"100%"}
                                              
                                                    className="transform object-cover object-center"
                                                /> 
                                                
                                </div>
                                <div className='relative gap-3 flex flex-row group justify-center items-center'>
                                    <div className=' absolute shrink-0 rounded-md left-0 z-50 bg-white !h-[3rem] !w-[3rem] opacity-30 flex items-center justify-center hover:opacity-100 group-hover:opacity-100 transform-all duration-300'
                                            onClick={()=>{handleScroll(-300)}}
                                        >
                                            <span className='text-black'><ArrowLeftOutlined></ArrowLeftOutlined></span>
                                        </div>
                                    <div className='relative flex flex-row gap-2 mt-2 overflow-scroll no-scrollbar p-2 scroll-smooth'
                                        ref={containerRef}
                                    >
                                    
                                        {currentImageList.map((item,index)=>{
                                            return(
                                                <div key={index}
                                                    onClick={()=>{setCurrentImage(item)}}
                                                >
                                                    <img
                                                    className={`object-center object-cover w-[10rem] aspect-video rounded-lg shadow-md  ${(currentImage == item)?'border-2 border-solid  border-blue-500 ' :'border border-solid  border-gray-100'} transform-all duration-100`}
                                                    alt=""
                                                    src={item}
                                                    
                                                />
                                                </div>
                                                
                                            )
                                        })}
                                        
                                    </div>
                                    <div className='absolute shrink-0 rounded-md right-0 z-50 bg-white !h-[3rem] !w-[3rem] opacity-30 flex items-center justify-center hover:opacity-100 group-hover:opacity-100 transform-all duration-300'
                                            onClick={()=>{handleScroll(300)}}
                                        >
                                            <span className='text-black'><ArrowRightOutlined></ArrowRightOutlined></span>
                                        </div>
                                    </div>
                                    
                            </div>
                            
                        </div>

                        {/* Right Column */}
                        
                        <div className="w-full lg:w-5/12  border-none flex flex-col lg:pl-5">
                        <div className='flex flex-row  mt-10 justify-between p-2'>
                            <Breadcrumb
                                items={[
                                {
                                    title: <span onClick={()=>{navigate('/')}} className=' hover:underline hover:-translate-y-1 duration-300 transition-transform '>Home</span>,
                                },
                                {
                                    title: <span onClick={()=>{navigate('/products/plantations')}} className=' hover:underline hover:-translate-y-1 duration-200 transition-transform '>Plantation Shutters</span>,
                                },
                                {
                                    title: 'PVC Plantation Shutters',
                                },
                                ]}
                            />
                        
                        </div>
            
                        <div className=' w-full  flex flex-col'>
                            {/* <span className='hedvig-letters-serif-regular text-6xl  my-5'>
                                Protecta Zip Awnings
                            </span> */}
                            <div className=' flex flex-col my-5 h-fit '>
                                <span className='hedvig-letters-serif-regular text-6xl '>
                                    PVC Plantation Shutters
                                </span>
                                <span className='hedvig-letters-sans-regular text-xl text-neutral-700 mt-5 '>
                                    From $254.55
                                </span>
                                <span className='hedvig-letters-sans-regular text-lg text-neutral-500 mt-5 '>
                                Enhance your space with our elegant and functional plantation shutters. Crafted with meticulous attention to detail, they add sophistication to any room. Enjoy privacy, natural light control, and durability, making them a lasting investment in style and comfort.
                                </span>
                        
                       
                            </div>
                            
                            
                                <Collapse
                                    
                                    size='large'
                                    defaultActiveKey={['1']}
                                    className='my-2'
                                    items={[{ key: '1', label: 'Colour'
                                    , children: 
                                    <div>
                                        
                                        <div className=' w-full flex flex-col'>
                                            <span className='hedvig-letters-sans-regular text-xl text-black mb-3'>Colour:</span>
                                            <div className='flex flex-wrap gap-2 mt-1'>
                                            {bracketColors?.map((item:any,index:number) =>{
                                                return(
                                                    <Tooltip key={index} placement="bottom" title={item.title}>
                                                        <div
                                                        
                                                        style={{ width: 50, height:50 }}
                                                        className={`bg-white cursor-pointer rounded-full flex flex-col items-center justify-center overflow-hidden  bg-transparent ${(currentSystemColor == index)?'border-4 border-solid  border-blue-500 -translate-y-1' :'border border-solid border-neutral-200'} shadow-md shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setCurrentSystemColor(index)
                                                            // setCurrentImage(item.src)
                                                            
                                                        }}
                                                        >
                                                            <div style={{ width: 75, height:75, background:item.color }} ></div>
                                                        </div>
                                                </Tooltip>
                                                )
                                            })}
                                            
                                            </div>
                                            
                                        </div>
                                    </div>
                                    
                                
                                }]}
                                />
{/*                                 
                                <div className={`w-full mt-5 mb-5 flex flex-col`}>
                                    <span className='hedvig-letters-sans-regular text-xl text-black mb-3 px-2'>Installation:</span>
                                    <div className='flex flex-row gap-3'>
                                      
                                                
                                                        <div
                                                
                                                        style={{height:100}}
                                                        className={`w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(installation == false)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setInstallation(false)
                                                        }}
                                                        >
                                                            
                                                            <span className='text-xl my-2'>DIY</span>
                                                        </div>
                                                        <div
                                                
                                                        style={{height:100}}
                                                        className={`w-1/2 cursor-pointer flex flex-col items-center justify-center overflow-hidden rounded-lg  bg-transparent ${(installation == true)?'border-2 border-solid  border-blue-500 -translate-y-1' :'border border-solid  border-gray-100'} shadow-md transform-all duration-200`}
                                                        onClick={()=>{
                                                            setInstallation(true)
                                                        }}
                                                        >
                                                            
                                                            <span className='text-xl my-2'>Professional <br></br> Installation</span>
                                                        </div>
                                        
                                        
                                                
                                    </div>
                                    </div> */}
                                
                                
                                
                    </div>
                    </div> 
                </div>
                </div>
                
               

                <div className='flex flex-col max-w-screen-2xl m-auto items-center justify-center mt-20 mb-10'>
                    <span className='text-2xl lg:text-5xl text-center hedvig-letters-serif-regular'>
                        Need help from our expert?
                    </span>
                    <span className='text-2xl text-center hedvig-letters-sans-regular underline transition-all duration-200 hover:translate-x-1 hover:text-neutral-500 mt-3'
                        onClick={()=>{navigate('/contact')}}
                    >
                        Contact us
                    </span>
                    
                </div>
            </Content>
         
        </div>
  )
}
